@if (loading()) {
  <div class="state-message">
    <qai-loading size="medium" />
  </div>
} @else if (loadError()) {
  <div class="state-message">
    {{ 'simulationBuilder.CALL_DETAILS_LOAD_ERROR' | transloco }}
  </div>
} @else {
  <tabs-inner-wrap>
    @if (!isKnowledgeCheck()) {
      <qai-alert class="author-override-alert" kind="warning"
        [title]="(showAuthorOverrideWarning() ? 'simulationBuilder.WHAT_USERS_SEE_OVERRIDE_WARNING_TITLE' : 'simulationBuilder.WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_TITLE') | transloco">
        {{ (showAuthorOverrideWarning() ? 'simulationBuilder.WHAT_USERS_SEE_OVERRIDE_WARNING_BODY' :
        'simulationBuilder.WHAT_USERS_SEE_DETAILS_OVERRIDE_EDITED_BODY') | transloco }}
      </qai-alert>
    }
    <what-users-see-card
      [title]="'simulationBuilder.WHAT_USERS_SEE_DESCRIPTION_TITLE' | transloco"
      [description]="'simulationBuilder.WHAT_USERS_SEE_DESCRIPTION_HELPER' | transloco"
    >
      <div content>
        <qai-field [label]="'simulationBuilder.WHAT_USERS_SEE_DESCRIPTION_FIELD_LABEL' | transloco">
          <textarea qai-textarea autosize [maxLines]="30" [formControl]="descriptionControl" qaiTrimLeading qaiPasteClean></textarea>
        </qai-field>
      </div>
    </what-users-see-card>

    <what-users-see-card
      [title]="'simulationBuilder.WHAT_USERS_SEE_DETAILS_TITLE' | transloco"
      [description]="'simulationBuilder.WHAT_USERS_SEE_DETAILS_HELPER' | transloco"
    >
      <div actions>
        <button qai-link class="preview-details-cta" (click)="previewDetailsModal()">
          {{ 'simulationBuilder.WHAT_USERS_SEE_PREVIEW_DETAILS_CTA' | transloco }}
        </button>
      </div>
      <div content>
        <div class="fields">
          <qai-field [label]="'simulationBuilder.WHAT_USERS_SEE_OVERVIEW_FIELD_LABEL' | transloco">
            <textarea qai-textarea autosize [maxLines]="30" [formControl]="overviewControl" qaiTrimLeading qaiPasteClean></textarea>
          </qai-field>

          <qai-field [label]="'simulationBuilder.WHAT_USERS_SEE_PERSONA_FIELD_LABEL' | transloco">
            <textarea qai-textarea autosize [maxLines]="30" [formControl]="personaControl" qaiTrimLeading qaiPasteClean></textarea>
          </qai-field>

          <qai-field
            [label]="'simulationBuilder.WHAT_USERS_SEE_SCORING_FIELD_LABEL' | transloco"
            [description]="'simulationBuilder.WHAT_USERS_SEE_SCORING_FIELD_HELPER' | transloco"
          >
            <textarea qai-textarea autosize [maxLines]="30" [formControl]="scoringControl" qaiTrimLeading qaiPasteClean></textarea>
          </qai-field>

          <qai-field [label]="'Additional section title'">
            <input qai-input type="text" qaiTrimLeading [formControl]="additionalSectionTitleControl" />
          </qai-field>

          <qai-field [label]="'Additional section information'">
            <textarea qai-textarea autosize [maxLines]="40" [formControl]="additionalSectionInfoControl" qaiTrimLeading qaiPasteClean></textarea>
          </qai-field>
        </div>
      </div>
    </what-users-see-card>
  </tabs-inner-wrap>

  <preview-simulations-details-modal
    [open]="openPreviewModal"
    [tabs]="previewTabs"
    (closeModal)="handlePreviewModalClose()"
  ></preview-simulations-details-modal>
}
